import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineChartComponent } from './line-chart.component';
import { CoreModule } from '@dm/core';

@NgModule({
    declarations: [LineChartComponent],
    exports: [LineChartComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
})
export class LineChartModule { }
